import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { DecimalPercentInput } from '@ui/components/form/DecimalPercentInput';
import { get, useFormContext } from 'react-hook-form';

export function NewPartUserCostForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext();
  const targetGrossMarginFieldPath = fieldPath('targetGrossMargin');
  const targetGrossMarginFieldError = get(
    form.formState.errors,
    targetGrossMarginFieldPath,
  );

  const targetGrossMarginFormHandlers = form.register(
    targetGrossMarginFieldPath,
  );

  return (
    <>
      <FormControl isInvalid={!!targetGrossMarginFieldError} isRequired>
        <FormLabel htmlFor={targetGrossMarginFieldPath}>
          Target Gross Margin:
        </FormLabel>

        <DecimalPercentInput
          {...targetGrossMarginFormHandlers}
          id={targetGrossMarginFieldPath}
        />

        <ErrorMessage
          name={targetGrossMarginFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />

        <FormHelperText>
          As a decimal percentage (e.g. 0.3 for 30%)
        </FormHelperText>
      </FormControl>
    </>
  );
}
